import { connect } from 'react-redux';
import { getRightPresetSelector } from 'redux-core/rights/selectors';

const mapStateToProps = (state) => ({
  preset: getRightPresetSelector(state),
});

export default connect(mapStateToProps);
